
















































































import Vue from "vue";
import FormField from "./AppFormField.vue";
import RelationshipField from "./RelationshipField.vue";

export default Vue.extend({
  name: "SequenceForm",
  components: { FormField, RelationshipField },
  props: {
    formFields: {
      type: Array as () => Array<FormField>,
      default: () => [] as FormField[]
    },
    loading: {
      type: Boolean,
      default: false
    },
    relatable: {
      type: Object,
      default: () => {
        return {};
      }
    },
    submitButtonText: {
      type: String,
      default: "Submit"
    }
  },

  data() {
    return {
      data: {} as {[key: string]: any},
      resetting: false,
      presets: [
        {
          title: '720p - 1280x720',
          width: 1280,
          height: 720
        },
        {
          title: '1080p - 1920x1080',
          width: 1920,
          height: 1080
        },
        {
          title: '2K - 2048x1152',
          width: 2048,
          height: 1152
        },
        {
          title: '2.5K - 2560x1440',
          width: 2560,
          height: 1440
        },
        {
          title: '4K - 3840x2160',
          width: 3840,
          height: 2160
        }
      ],
      selectedPreset: {
        title: "Custom",
        width: 0,
        height: 0
      }
    };
  },

  computed: {
    fields(): FormField[] {
      let fields = this.formFields.filter(field => field.display == "field");
      fields = fields.map(field => {
        if (field.fieldTag === "select" && typeof field.options === "string") {
          const optionsField = fields.find(
            optionField => optionField.key == field.options
          );
          const options = optionsField ? optionsField[field.options] || [] : [];
          return Object.assign(field, { options });
        } else {
          return field;
        }
      });
      return fields;
    },
    meta(): FormField[] {
      return this.formFields.filter(field => field.display == "meta");
    },
    relationships(): FormField[] {
      return this.formFields.filter(field => field.display == "relationship");
    }
  },

  methods: {
    dataChange(key, value) {
      this.$set(this.data, key, value);
      if (key === 'width' || key === 'height') this.selectedPreset = { title: "Custom", width: this.data.width, height: this.data.height }
    },
    initData() {
      this.$schema.sort(this.formFields, ["order", "label"]).forEach(field => {
        if (field.key && field.key !== "preview") {
          if (typeof field.value !== "undefined") {
            this.$set(this.data, field.key, field.value);
          } else {
            this.$set(this.data, field.key, field.defaultValue);
          }
        }
        if (field.key == 'width') this.selectedPreset.width = field.value
        if (field.key == 'height') this.selectedPreset.height = field.value
      });
    },
    reset() {
      this.resetting = true;
      this.initData;
      this.resetting = false;
    },
    submit() {
      const data = this.data
      if (this.selectedPreset.title !== "Custom") {
        data.width = this.selectedPreset.width
        data.height = this.selectedPreset.height
      }
      this.$emit("submit", data);
    }
  },

  created() {
    this.initData();
  },

  mounted() {}
});
